import styled from "@emotion/styled";
import * as React from "react";

import { Loader } from "@livechat/design-system";

import { fetchScript } from "helpers/resources";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function isRecurlyJsFetched() {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return typeof (window as any).recurly === "object";
}

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;

/**
 * HOC that ensures Recurly.js library is loaded before the component is rendered.
 *
 * @param WrappedComponent
 */
export function withRecurlyJs<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line react/display-name
  return class extends React.Component<P> {
    state = {
      recurlyJsFetched: isRecurlyJsFetched(),
    };

    private unmounted = false;

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentDidMount() {
      if (!this.state.recurlyJsFetched) {
        fetchScript("https://js.recurly.com/v4/recurly.js").then(() => {
          if (this.unmounted === false) {
            this.setState({
              recurlyJsFetched: true,
            });
          }
        });
      }
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentWillUnmount() {
      this.unmounted = true;
    }

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    render() {
      if (!this.state.recurlyJsFetched) {
        return (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        );
      }

      return <WrappedComponent {...this.props} />;
    }
  };
}
